import { Injectable, signal } from '@angular/core';
import { AppSettingsService, ISettingsData } from '@ds/ng-wt-app-settings';

import { RequestMethod, SgWebHttpClient } from '@ds/ng-wt-helpers/http';

import { forkJoin, map, Observable, of, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class SettingsHelperService {
  path = '/resources/app-settings/data/settings-data.json';


  constructor(
    private settingService: AppSettingsService,
    private http: SgWebHttpClient
  ) {}

  private loginChanges = new Subject<any>();

  getLoginSignal() {
    return this.loginChanges.asObservable();
  }

  setLoginSignal(value: any) {
    this.loginChanges.next(value);
  }

  /**
   *
   * Example method for the getting data from Mock Json
   * Require to replace your method
   * Should delete the settings-data.json file after replacing the method
   */
  getDataFromAPI() {
    /**
     * Added this function for Demo Purpose only,
     * Required to integrate with the API
     */
    let settings = window.localStorage.getItem('settings');
    if (settings && settings !== 'undefined') {
      return of(JSON.parse(settings));
    } else {
      return this.http.restAPIObservable<any>(
        RequestMethod.GET,
        `${this.path}`
      );
    }
  }
  resetBrandingSettings() {
    this.http
      .restAPIObservable<any>(RequestMethod.GET, `${this.path}`)
      .subscribe((response) => {
        this.settingService.resetBrandingSettings(response.BrandingSettings);
      });
  }

  getApplicationSetting(): Observable<any> {
    const settings: ISettingsData = <ISettingsData>{
      GeneralSettings: null,
      BrandingSettings: null,
      CustomImageData: null,
      CustomLoGoData: null,
      CustomVideoData: null,
    };
    const appSettings$ = this.getDataFromAPI();
    /**
     * Get any uploaded media file details
     */

    // const additionalSettings$ = this.http.getUploadedMediaFileDetails();  //API Integration
    const additionalSettings$ = this.getCustomMediaDetails();
    return forkJoin([appSettings$, additionalSettings$]).pipe(
      map(([appSettingsResponse, additionalSettingsResponse]: [any, any]) => {
        let applicationSetting = this.processSettings(
          appSettingsResponse,
          settings
        );
        let mediaSettings = this.setCustomMediaDetails(
          additionalSettingsResponse,
          settings
        );
        let finalSettings = {
          ...applicationSetting,
          ...mediaSettings,
        };
        return finalSettings;
      })
    );
  }

  getCustomMediaDetails() {
    let customMedia = window.localStorage.getItem('customMediaData');
    if (customMedia) {
      return of(JSON.parse(customMedia));
    } else {
      let customMediaData = {
        CustomImageData: null,
        CustomLoGoData: null,
        CustomVideoData: null,
      };
      return of(customMediaData);
    }
  }
  /**
   * modify the settings based on the response
   * @param response
   * @param setting
   * @returns
   */
  processSettings(response: any, settings: any) {
    this.handleLocalStorage(response);
    if (response.GeneralSettings) {
      this.settingService.initialGeneralSettings(response.GeneralSettings);
    }
    if (response.BrandingSettings) {
      this.settingService.initBrandingSettings(response.BrandingSettings);
    }
    return response;
  }
  handleLocalStorage(response) {
    let settings = window.localStorage.getItem('settings');
    if (settings) {
      window.localStorage.removeItem('settings');
    }
    window.localStorage.setItem('settings', JSON.stringify(response));
  }

  setCustomMediaDetails(response, settings) {
    if (response) {
      let settings = { ...response };
      /**
       * Require to call this method once custom media details are available
       */
      this.settingService.initCustomMediaSettings(settings);
      return settings;
    }
  }
}
